import * as React from 'react'; 
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { styled } from '@mui/system';
import { SxProps, Theme } from '@mui/system';

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& label.Mui-focused': {
    color: '#A0AAB4',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#B2BAC2',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#E0E3E7',
    },
    '&:hover fieldset': {
      borderColor: '#B2BAC2',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#6F7E8C',
    },
    '& input[type=number]': {
        '-moz-appearance': 'textfield', 
    },
    '& input[type=number]::-webkit-outer-spin-button': {
        '-webkit-appearance': 'none', 
        margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none', 
        margin: 0,
    },
  },
}));

type ImputProps = {
    id?: string;
    label?: string;
    placeholder?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    backgroundColor?: string;
    borderColor?: string;
    textColor?: string;
    disabled?: boolean;
    fullWidth?: boolean;
    sx?: SxProps<Theme>; 
    size?: 'small' | 'medium' ;
    type: string;
    value?: string;
};


const GenericImput: React.FC<ImputProps> = ({
    id,
    label,
    placeholder,
    onChange,
    onKeyDown,
    backgroundColor = '#fff',
    borderColor = '#d3d3d3',
    textColor = '#000',
    disabled = false,
    fullWidth = true,
    sx,
    size = 'medium',
    type = 'text',
    value
}) => {
  return (
    <StyledTextField
    id={id}
    label={label}
    placeholder={placeholder}
    onChange={onChange}
    onKeyDown={onKeyDown}
    disabled={disabled}
    fullWidth={fullWidth}
    type={type}
    value={value}
    sx={{
      backgroundColor: backgroundColor,
      color: textColor,
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: borderColor,
        },
      },
      ...sx,
    }}
  />
  );
};

export default GenericImput;
